import {
  Component,
  inject,
  OnInit,
  signal,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { AppCommonModule } from '../../../../../../../components/app.common.module';
import { FinancialProductService } from '../../financial-product.service';
import { BaseComponent } from '@app/components/base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NewFinancialProductTemplateComponent } from '../new-financial-product-template/new-financial-product-template.component';
import { NgFor, NgIf } from '@angular/common';
import { SubBrandService } from '@app/pages/quote/standard-quote/catalogs/sub-brand/sub-brand.service';
import { FileType } from '@app/models/fileTypes.enum';

@Component({
  selector: 'app-new-financial-product-readonly',
  standalone: true,
  imports: [AppCommonModule, NewFinancialProductTemplateComponent, NgFor, NgIf],
  templateUrl: './new-financial-product-readonly.component.html',
  styleUrls: ['./new-financial-product-readonly.component.scss'],
})
export class NewFinancialProductReadonlyComponent
  extends BaseComponent
  implements OnInit
{
  public productImg = signal('');
  private readonly subBrandService = inject(SubBrandService);
  @ViewChild('modalTemplateConfirmation')
  modalTemplateConfirmation!: TemplateRef<any>;

  module: '';
  isLoading: boolean = false;
  id: number;
  form: FormGroup;
  brand: any;
  subBrand: any;

  constructor(
    private router: Router,
    private financialProductService: FinancialProductService,
    public activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    super();
    this.form = this.fb.group({
      name: [''],
      modelType: [''],
      brandId: [''],
      subBrandId: [''],
      classification: [''],
      year: [''],
      price: [''],
      maxPrice: [0],
      currency: [''],
      modelCode: [''],
      enabled: [false],
      residualModelValues: [[]],
    });
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((p) => {
      this.id = Number(p.get('id')) ?? null;
      if (this.id) {
        this.getModelById();
      }
    });
  }

  getFile(id: number) {
    if (id === 0) return;
    this.isLoading = true;
    this.subBrandService.getAttachmentByElementId(id, FileType.SUB_BRAND).subscribe({
      next: (response: any) => {
        if (response.data.length > 0) {
          const row = response.data[0];
          this.productImg.set(row.publicUrl || row.urlSource || '');
        } else {
          this.productImg.set('');
        }
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        this.productImg.set('');
        if (error.status === 404) {
          return;
        }
      },
    });
  }

  getModelById() {
    this.isLoading = true;
    this.financialProductService.getModelById(this.id).subscribe({
      next: (response) => {
        const data = response.data;
        this.form.patchValue({
          ...data,
          subBrandId: data.subBrand?.id || '',
        });

        const brandId = data.subBrand?.brand?.id || data.brand?.id;
        
        if (brandId) {
          this.financialProductService.getBrand().subscribe({
            next: (response) => {
              this.brand = response.data.find(
                (brand: any) => brand.id === brandId
              );
            },
          });

          this.financialProductService
            .getSubBrandsByIdBrand(brandId)
            .subscribe({
              next: (response) => {
                this.subBrand = response.data.find(
                  (subBrand: any) =>
                    subBrand.id === data.subBrand?.id
                );
                this.isLoading = false;
              },
            });
        } else {
          this.isLoading = false;
        }

        if (data.subBrand?.id) {
          this.getFile(data.subBrand.id);
        }
        this.form.disable();
      },
      error: () => {
        this.isLoading = false;
        this.showNotificationError(
          'Ha ocurrido un error, el producto financiero no se pudo obtener.'
        );
      },
    });
  }

  /** Valores residuales ordenados por plazo (igual que en modo edición). */
  get residualModelValuesSorted(): any[] {
    const values = this.form.get('residualModelValues')?.value ?? [];
    return [...values].sort((a, b) => Number(a?.term) - Number(b?.term));
  }

  back() {
    this.router.navigate(['financial-product/list']);
  }
}
